import { Button, Col, Form, Row, Tag, Upload } from "antd";
import React, { useEffect, useState } from "react";
import CustomTable from "../../components/styledComponent/styledTable";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { ShowNotification } from "../../components/notification/notification";
import {
  exportPurchaseOrder,
  getOrder,
  importSalesOrderData,
  updateOrders,
} from "../../server/purchaseOrderServices";
import { useNavigate, useParams } from "react-router-dom";
import {
  StyledButton,
  StyledInput,
  StyledSelect,
} from "../../components/styledComponent/styledElements";
import { useAppContext } from "../../contexts/appContext";
import { IoDownloadOutline } from "react-icons/io5";
import { PiUploadSimple } from "react-icons/pi";
import { CiCircleCheck, CiEdit } from "react-icons/ci";
import { RxCrossCircled } from "react-icons/rx";

const PurchaseOrderDetails = () => {
  const productColumn = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      editable: true,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      editable: true,
    },
    {
      title: "Rate",
      dataIndex: "display_rate",
      key: "display_rate",
      editable: true,
    },
    {
      title: "Discount",
      dataIndex: "total_discount",
      key: "total_discount",
      editable: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Tax",
      dataIndex: "total_tax",
      key: "total_tax",
    },
    {
      title: "Net Amount",
      dataIndex: "net_amount",
      key: "net_amount",
    },
    {
      title: "Stock",
      dataIndex: "available",
      key: "available",
      editable: true,
    },
    {
      title: "",
      dataIndex: "tableAction",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="flex justify-center gap-2 content-center">
            <Button
              className="icon-only-button"
              icon={<CiCircleCheck size={32} color={"green"} />}
              onClick={() => SaveProductEdit(record)}
            />
            <Button
              className="icon-only-button"
              icon={<RxCrossCircled size={32} color={"red"} />}
              onClick={cancel}
            />
          </div>
        ) : (
          <StyledButton
            className="icon-only-button"
            icon={<CiEdit />}
            height={32}
            border="black"
            background="#ededed"
            color="Black"
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          />
        );
      },
    },
  ];
  const { startLoading, stopLoading, user } = useAppContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [refetch, setRefetch] = useState(false);
  const [orderData, setOrderData] = useState();
  const [editingKey, setEditingKey] = useState("");
  const orderStatus = [
    { label: "Placed", value: "Placed" },
    { label: "Pending", value: "Pending" },
    { label: "Preparing", value: "Preparing" },
    { label: "Shipped", value: "Shipped" },
    { label: "Delivered", value: "Delivered" },
  ];
  var userRole = user?.role;
  var purchaseOrderPermission = user?.access?.purchase_order;

  const isEditing = (record) => record.code === editingKey;
  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.code);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const SaveProductEdit = async (record) => {
    try {
      const row = await form.validateFields();
      const updatedRecord = [{ ...record, ...row }];
      updateProductDetails(updatedRecord);
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <StyledSelect
          width={"200px"}
          options={
            dataIndex === "unit"
              ? [
                  { label: "Box", value: "Box" },
                  { label: "Piece", value: "Piece" },
                ]
              : [
                  { label: "In Stock", value: "InStock" },
                  { label: "Out of Stock", value: "OutOfStock" },
                ]
          }
        />
      ) : (
        <StyledInput type="number" width={"80px"} />
      );
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[{ required: true, message: `Please Input ${title}!` }]}
            normalize={
              inputType === "select"
                ? undefined
                : (value) => (value ? parseInt(value, 10) : 0)
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const mergedColumns = productColumn.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        inputType:
          col.dataIndex === "quantity" ||
          col.dataIndex === "display_rate" ||
          col.dataIndex === "total_discount"
            ? "number"
            : col.dataIndex === "unit" || col.dataIndex === "available"
            ? "select"
            : "number",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const fetchPurchaseOrder = async () => {
    startLoading();
    try {
      let res = await getOrder(id);
      if (!res.data) {
        ShowNotification({
          type: "error",
          message: "Sales Order not Found",
        });
        navigate("/sales-order");
      } else {
        setOrderData(res.data.purchase_order);
      }
      setRefetch(false);
    } catch (error) {
      console.error(error);
    } finally {
      stopLoading();
    }
  };
  const handleSalesOrderImport = (files) => {
    startLoading();
    importSalesOrderData(id, files)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Data Imported Successfully",
        });
        setRefetch(true);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleFileChange = (info) => {
    if (info.fileList && info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      handleSalesOrderImport(file);
    }
  };
  const handleOnExportClick = async () => {
    const response = await exportPurchaseOrder(id);
    const blob = new Blob([response], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "salesOrder.csv";
    link.click();
  };
  const updateProductDetails = (records) => {
    updateOrders(id, { products: records }).then(() => {
      ShowNotification({ type: "success", message: "Sales Order updated" });
      setRefetch(true);
      setEditingKey("");
    });
  };
  useEffect(() => {
    fetchPurchaseOrder();
  }, [refetch]);
  const updateOrderStatus = (val) => {
    updateOrders(id, { status: val }).then(() => {
      ShowNotification({ type: "success", message: "Order status updated" });
      setRefetch(true);
    });
  };
  return (
    <div>
      <StyledContentCard title={"Sales Order Details"}>
        <Row className="my-3 " justify={"space-between"}>
          <Col>
            {orderData?.customer_confirmed && (
              <Tag
                className="quotation-tag"
                color={orderData?.customer_confirmed && "success"}
              >
                {"Customer Confirmed"}
              </Tag>
            )}
          </Col>
          <Col className="flex gap-3">
            {(userRole === "Admin" ||
              {
                /*importPermission?.create*/
              }) && (
              <Upload
                showUploadList={false}
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                accept=".csv,.xlsx"
                onChange={handleFileChange}
              >
                <StyledButton icon={<IoDownloadOutline size={20} />}>
                  {"Import"}
                </StyledButton>
              </Upload>
            )}
            {(userRole === "Admin" ||
              {
                /*importPermission?.create*/
              }) && (
              <StyledButton
                icon={<PiUploadSimple size={20} />}
                onClick={handleOnExportClick}
              >
                {"Export"}
              </StyledButton>
            )}
          </Col>
        </Row>
        <Row className="my-2" justify={"end"}>
          {(userRole === "Admin" || purchaseOrderPermission?.edit) && (
            <Col>
              <StyledSelect
                placeholder="Sales Order Status"
                width={"200px"}
                options={orderStatus}
                onChange={(val) => updateOrderStatus(val)}
                value={orderData?.status}
              />
            </Col>
          )}
        </Row>
        <Row className="my-4">
          <Col span={6}>
            <div className="details-key">Gross Amount</div>
            <div className="details-value">
              {orderData && orderData.gross_amount ? orderData.gross_amount : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Discount</div>
            <div className="details-value">
              {orderData && orderData.total_discount
                ? orderData.total_discount
                : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Tax</div>
            <div className="details-value">
              {orderData && orderData.total_tax ? orderData.total_tax : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Grand Total</div>
            <div className="details-value">
              {orderData && orderData.grand_total ? orderData.grand_total : 0}
            </div>
          </Col>
        </Row>
        <Form form={form} component={false}>
          <CustomTable
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            data={orderData?.products}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={{
              onChange: cancel,
            }}
          />
        </Form>
      </StyledContentCard>
    </div>
  );
};

export default PurchaseOrderDetails;
